import axios from 'axios';

const GRAPH_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;

const API = {
  async graph( query ) {
    try {
      const response = await axios({
        url: GRAPH_ENDPOINT,
        headers: { 'content-type': 'application/json' },
        method: 'post',
        data: JSON.stringify({ query: query })
      })
      return { status: response.status, data: response.data.data };
    } catch(error) {
      console.log( error.message )
      return null;
    }
  },
  async getBankPartners() {
    const q = `{
      get_car_insurance_bank_partners {
        title
        cag_bank_id
        bank_name
      }
    }`;
    try {
      const response = await axios({
        url: GRAPH_ENDPOINT,
        headers: { 'content-type': 'application/json' },
        method: 'post',
        data: JSON.stringify({ query: q })
      })
      return { status: response.status, data: response.data.data };
    } catch(error) {
      console.log( error.message )
      return null;
    }
  }
}

export default API;